<template>
  <v-card class="mb-2" outlined>
    <v-card-text class="font-weight-bold" style="text-align: center;">
      <v-btn v-if="back" icon color="pink" @click="clicked" class="btn-back">
        <v-icon>mdi-arrow-left-thick</v-icon>
      </v-btn>
      MAPPING BUILDINGS
    </v-card-text>
  </v-card>
</template>

<script>
import { EventBus } from "@/utils/eventBus";

export default {
  name: "NavigationLabel",
  data() {
    return {
      back: false
    };
  },
  created() {
    EventBus.$on("TYPE_BACK_START", value => {
      if (!value) {
        this.back = true;
      }
    });
  },
  methods: {
    clicked() {
      location.reload();
    }
  }
};
</script>

<style scoped>
.btn-back {
  left: 6px;
  top: 9.8px;
  position: absolute;
}
</style>
